import { useQuery } from '@tanstack/react-query';

const useSvgContent = (url: string) => {
  const fetchSvgContent = async (): Promise<string> => {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch SVG content: ${response.statusText}`);
    }
    let svgData = await response.text();
    svgData = svgData.replace('<svg', '<svg height="600px" width="100%"');
    return svgData;
  };

  return useQuery({
    queryKey: ['svgContent', url],
    queryFn: fetchSvgContent,
    refetchOnWindowFocus: false
  });
};

export default useSvgContent;
